import { invoiceStatusSchema } from './status'

export const CANCEL_INVOICE_STATUS = [
  invoiceStatusSchema.Enum.CANCEL_NOSHOW_T,
  invoiceStatusSchema.Enum.CANCEL_PAID,
  invoiceStatusSchema.Enum.NOSHOW_BOTH,
  invoiceStatusSchema.Enum.NOSHOW_S,
]

export const HIDE_CANCEL_INVOICE_STATUS = [invoiceStatusSchema.Enum.COMPLETED, invoiceStatusSchema.Enum.PREFINISH]

export const ALL_COMPLETED_INVOICE_STATUS = [...HIDE_CANCEL_INVOICE_STATUS, ...CANCEL_INVOICE_STATUS]
